import { render, staticRenderFns } from "./FilePreventivi.vue?vue&type=template&id=6d19e807&scoped=true&"
import script from "./FilePreventivi.vue?vue&type=script&lang=js&"
export * from "./FilePreventivi.vue?vue&type=script&lang=js&"
import style0 from "./FilePreventivi.vue?vue&type=style&index=0&id=6d19e807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19e807",
  null
  
)

export default component.exports